export const round = (value, precision = 1) => {
  const factor = Math.pow(10, precision)
  return Math.round(value * factor) / factor
}
